import _regeneratorRuntime from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: 'pc-right-bar',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '右侧悬浮导航',
          icon: 'el-icon-chat-line-round',
          content: {
            cartImg: '',
            actCartImg: '',
            cartText: '',
            serviceImg: '',
            actServiceImg: '',
            serviceText: '',
            isCart: true,
            isService: true,
            list: []
          },
          config: [{
            label: '右侧悬浮导航',
            name: 'list',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              bftImg: {
                label: '激活图片',
                value: 'actImg'
              },
              link: {
                label: '链接',
                value: 'link'
              }
            }
          }, {
            label: '是否显示购物车',
            name: 'isCart',
            type: 'isOpen',
            value: ''
          }, {
            label: '购物车图片',
            name: 'cartImg',
            type: 'image',
            value: ''
          }, {
            label: '购物车激活图片',
            name: 'actCartImg',
            type: 'image',
            value: ''
          }, {
            label: '购物车文字',
            name: 'cartText',
            type: 'input',
            value: ''
          }, {
            label: '是否显示客服',
            name: 'isService',
            type: 'isOpen',
            value: ''
          }, {
            label: '客服图片',
            name: 'serviceImg',
            type: 'image',
            value: ''
          }, {
            label: '客服激活图片',
            name: 'actServiceImg',
            type: 'image',
            value: ''
          }, {
            label: '客服文字',
            name: 'serviceText',
            type: 'input',
            value: ''
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      dialog: true,
      rightHeight: 0
    };
  },
  computed: {
    catNum: function catNum() {
      var _this$$store$state$ca;
      return (_this$$store$state$ca = this.$store.state.catCount) === null || _this$$store$state$ca === void 0 ? void 0 : _this$$store$state$ca.totalCount;
    },
    siteCustomer: function siteCustomer() {
      return this.$store.state.siteCustomer;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.rightHeight = _this.$refs.rightBar.clientHeight;
      var list = document.querySelectorAll('.j-right-tab') || [];
      list.forEach(function (item) {
        item.addEventListener('mouseenter', function (dom) {
          var imgs = dom.target.querySelectorAll('img') || [];
          if (imgs[0]) {
            imgs[0].style.display = 'none';
          }
          if (imgs[1]) {
            imgs[1].style.cssText = 'display: inline-block !important';
          }
        });
        item.addEventListener('mouseleave', function (dom) {
          var imgs = dom.target.querySelectorAll('img') || [];
          if (imgs[0]) {
            imgs[0].style.cssText = 'display: inline-block !important';
          }
          if (imgs[1]) {
            imgs[1].style.display = 'none';
          }
        });
      });
    });
  },
  methods: {
    openService: function openService() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this2.siteCustomer.state == 10) {
                window.open("tencent://message/?uin=".concat(_this2.siteCustomer.platformAccount, "&Site=\u5728\u7EBFQQ&Menu=yes"));
              } else {
                _this2.$message.warning('平台未设置或未开启客服');
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};